import { connect } from 'react-redux';
import { withStateHandlers } from 'recompose';

import { finishLockdown } from '../../actions/lockdown';

import LockdownForm from './LockdownForm';

const mapStateToProps = (state) => ({
  totalLockdownSeconds: state.auth.lockdown.totalLockdownSeconds,
  secondsLeft: state.auth.lockdown.unfreezeTimestamp
    ? Math.floor((Number(state.auth.lockdown.unfreezeTimestamp) - Date.now()) / 1000)
    : 0,
});

export default connect(
  mapStateToProps,
  { finishLockdown },
)(withStateHandlers(
  ({ secondsLeft }) => ({ secondsLeft }),
  { setSecondsLeft: () => (secondsLeft) => ({ secondsLeft }) },
)(LockdownForm));
